import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
// import ReactGA from 'react-ga';

import Caro from '../../Carousels/Caro/Caro';

import { lang } from '../../../il8n/lang';
import { toggleInterstitial } from '../../../Actions/Index';

import './Home.css';

/**
 * Home
 * @constructor
 */

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
        };

        this.toggleModal = this.toggleModal.bind(this);
    }
    componentDidMount() {
        this.props.dispatch(toggleInterstitial(false, '', ''));
    }

    toggleModal(vid) {
        this.setState(state => ({
            modalOpen: !state.modalOpen,
        }));
    }

    disableDragging(e){
        e.preventDefault();
        return false;
    }
    render() {
        // let {gaToggle} = this.props;
        return (
            <div>
                <Helmet title={lang.home.title + lang.helmet.siteTitle} />
                <div className='home'>
                    <Caro
                        respSlidesToShow={1}
                        slidesToShow={1}
                        frameOverflow={false}
                        insertClass={'caro--homebanner'}
                        initialSlideHeight={660}
                        dragging={true}
                        withoutControls={true}
                        autoplay={true}
                        autoplayInterval={2500}
                    >
                        {lang.home.slides.map((slide, index) => {
                            let img = this.state.mobileView
                                ? slide.mobileImg
                                : slide.img;
                            return (
                                    <img onDragStart={this.disableDragging} className={'caro__img'} key={index} alt={slide.heading} src={img} />
                                
                            );
                        })}
                    </Caro>

                    <div className='section promoblock section--altBg'>
                        <div className='flex-container'>

                        <div className='flex-row flex-row--align-h-center'>
                                {lang.home.downloads && lang.home.downloads.map(({image, url, label}, index) => {
                                    return (
                                        <div key={index} className='flex-col-sm-3'>
                                            <div className='flex-row flex-row--align-h-center'>
                                                <a href={url}>
                                                    <img
                                                        className='imageclass'
                                                        src={image}
                                                        alt={label}
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>

                            <div className='flex-row flex-row--align-h-center'>

                                <div
                                    className='flex-col-sm-3 mod-centered mod-bgimage'>
                                    <div className='flex-col-sm-12'>
                                        <img
                                            className='imageclass'
                                            src={lang.home.promoblock.imageUrl}
                                            alt={lang.home.promoblock.imageUrl}
                                            />
                                    </div>
                                </div>

                                <div className='flex-col-sm-6 list__container'>
                                    <h2>{lang.home.promoblock.title}</h2>
                                    <ul className='list'>
                                    {lang.home.promoblock.bulletPoints && lang.home.promoblock.bulletPoints.map((bullet, index)=> {
                                        return (
                                            <li key={index} className='list__item'><span>{bullet}</span></li>
                                        )
                                    }) }
                                    </ul>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        lang: state.lang,
        gaToggle: state.gaToggle,
    };
}

Home.propTypes = {
    dispatch: PropTypes.func,
};

export default connect(mapStateToProps)(Home);
